import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';

const languages = [
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
  },
  {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸',
  },
  {
    code: 'fr',
    name: 'Français',
    flag: '🇫🇷',
  },
  {
    code: 'de',
    name: 'Deutsch',
    flag: '🇩🇪',
  },
];

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const currentLanguage =
    languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant='ghost'
        size='sm'
        leftIcon={<FaGlobe />}
        rightIcon={<Text fontSize='xs'>{currentLanguage.flag}</Text>}
        color={useColorModeValue('gray.700', 'gray.200')}
        _hover={{
          bg: useColorModeValue('gray.100', 'gray.700'),
        }}
      >
        {currentLanguage.code.toUpperCase()}
      </MenuButton>
      <MenuList
        bg={useColorModeValue('white', 'gray.800')}
        borderColor={useColorModeValue('gray.200', 'gray.700')}
      >
        {languages.map(lang => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            icon={<Text fontSize='sm'>{lang.flag}</Text>}
            color={useColorModeValue('gray.700', 'gray.200')}
            bg={
              i18n.language === lang.code
                ? useColorModeValue('primary.50', 'primary.900')
                : 'transparent'
            }
            _hover={{
              bg: useColorModeValue('gray.100', 'gray.700'),
            }}
          >
            {lang.name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguageSelector;
